interface PriorityIconProps {
  priority: 'high' | 'low';
  size?: number;
}

/**
 * Priorita ve stylu známém z Jiry a spol.: dvojitý chevron nahoru = vysoká,
 * dolů = nízká (barvu řídí CSS přes currentColor). Dvojitý záměrně,
 * aby se ikona nepletla se sbalovací šipkou.
 */
export const PriorityIcon: React.FC<PriorityIconProps> = ({ priority, size = 18 }) => (
  <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
    {priority === 'high' ? (
      <>
        <path d="M6 12.5l6-5 6 5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 18l6-5 6 5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </>
    ) : (
      <>
        <path d="M6 6l6 5 6-5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 11.5l6 5 6-5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </>
    )}
  </svg>
);

export default PriorityIcon;
